module.exports = __webpack_public_path__ + "media/assets/images/authors/davide_disomma-bab484760792ce2bd0a72b7edf3acaf3.jpg";